// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { Branding } from './branding.model';

const branding: Branding = {
  companyName: 'Caimán',
  logoUrl: 'assets/img/logo.png',
  logoDarkUrl: 'assets/img/logo-dark.png',
  logoLoginUrl: 'assets/img/logo-login.png',
  sidebarBackgroundUrl: 'assets/img/sidebar-bg/01.jpg'
};

export const environment = {
  production: false,
  apiUrl: 'https://api.stg.produccion.caiman.com.ar/v1',
  file: 'https://api.stg.produccion.caiman.com.ar',
  planSearchUrl: 'http://192.168.0.4/tcsearch/plano60.asp',
  plan3dUrl: 'http://192.168.0.4/jt/',
  featureFlags: {
    workplanTasks: true
  },
  branding
};
